// @flow
import * as React from "react"
import NavBar from "@kiwicom/nitro/lib/components/NavBar"
import { connect } from "react-redux"
import NavbarStarred from "@kiwicom/frontend-app/scripts/modules/Navbar/components/NavbarStarred/NavbarStarred"
import DebugModal from "@kiwicom/frontend-app/scripts/modules/Debug/DebugModal"
import SubscriptionModal from "@kiwicom/frontend-app/scripts/modules/Auth/SubscriptionModal"

import { createSplitsterValueSelector } from "common/services/utils/splitsterSelector"
import * as nitroSideEffects from "common/utils/nitroSideEffects"
import HeaderLinks from "common/components/HeaderLinks/HeaderLinks"
import MainView from "common/components/MainView/MainView"
import HeaderData from "../browser/HeaderData"
import changeLanguage from "common/utils/changeLanguage"
import cuckoo from "common/services/cuckoo/cuckoo"
import { IFRAME_EVENT_NAMES } from "common/consts/tracking"
import { showModal } from "common/services/modals/actions"
// NavBar imports
import { openHelp } from "common/modules/SmartFAQ/services/SmartFAQDuck"
import mmbSelectTrip from "common/services/auth/mmbSelectTrip"
import { getLanguage } from "common/services/options/reducer"
import checkDebugEnabled from "common/utils/checkDebugEnabled"

type Props = {|
  children: React.Node,
  language: string,
  newDesign: boolean,
  openFAQ: () => void,
  showModal: (modal: string, obj: {| activeTab: string |}) => void,
|}

class Root extends React.PureComponent<Props> {
  componentDidMount() {
    cuckoo.iframeTracking(IFRAME_EVENT_NAMES.PAGE_VIEW)
  }

  render() {
    const { language, newDesign, openFAQ, children } = this.props
    return (
      <MainView
        {...this.props}
        onChangeLanguage={changeLanguage}
        navbar={
          <NavBar
            headerLinks={<HeaderLinks newDesign={newDesign} searchForm={null} />}
            subscription={<SubscriptionModal />}
            debug={Boolean(checkDebugEnabled()) && <DebugModal />}
            starred={<NavbarStarred />}
            onOpenFaq={openFAQ}
            onSaveLanguage={changeLanguage}
            onSelectTrip={id => mmbSelectTrip(language, id)}
            onSetModal={nitroSideEffects.modals}
            onLogoClick={nitroSideEffects.logoClick}
            portal="modals"
            newDesign={newDesign}
          />
        }
      >
        <HeaderData />
        {children}
      </MainView>
    )
  }
}

// $FlowFixMe TODO: plz add type when updating
export default connect(
  state => ({
    // navbar
    language: getLanguage(state),
    newDesign: createSplitsterValueSelector("NAVBAR_REDESIGN")(state) === "on",
  }),
  {
    // navbar
    openFAQ: () => openHelp(null),
    showModal,
  },
)(Root)
